import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class CrmLabelListService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-lists';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-lists';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-lists';
    this.httpClient = http;
  }
}
